import { render, staticRenderFns } from "./bind-theme.vue?vue&type=template&id=56fa22c5&scoped=true&"
import script from "./bind-theme.vue?vue&type=script&lang=js&"
export * from "./bind-theme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa22c5",
  null
  
)

export default component.exports